<div class="flex w-full h-full items-center justify-end">
  <button mat-icon-button [matMenuTriggerFor]="menu" y42StopPropagation>
    <y42-icon icon="ellipsis" [class]="state.triggerIconClass"></y42-icon>
  </button>
</div>

<mat-menu #menu="matMenu">
  <div
    *ngFor="let option of state.options; trackBy: trackByValue"
    [matTooltip]="option.permissionAllowed ? '' : option.permissionTooltip"
  >
    <button mat-menu-item (click)="option.action()" [class]="option.class" [disabled]="!option.permissionAllowed">
      <span>{{ option.label }}</span>
    </button>
  </div>
</mat-menu>
